import { gql } from '@apollo/client';

export const GET_EMISSION_FACTORS_QUERY = gql`
  query GetEmissionFactors($input: GetEmissionFactorRequest!) {
    getEmissionFactors(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        start_date
        end_date
        factor
        source
        deleted
        metric
        metric_group
        target_year
        category
        country
      }
    }
  }
`;
